"use strict";

exports.__esModule = true;
exports.parseResultsUrl = exports.generateFiltersfromPageData = exports.createResultsUrl = void 0;

var _require = require("@starberry/gatsby-library-common/BasicUtils"),
    removeSpecialChar = _require.removeSpecialChar;

var createResultsUrl = function createResultsUrl(props) {
  var searchtypePath = "";
  var areaPath = "";
  var bedPath = "";
  var pricePath = "";
  var buildingPath = "";
  var sortPath = "";
  var layoutPath = "";

  if ((props == null ? void 0 : props.search_type) === "buy") {
    searchtypePath = "for-sale/";
  } else if ((props == null ? void 0 : props.search_type) === "rent") {
    searchtypePath = "to-rent/";
  } else {
    searchtypePath = "new-homes/for-sale/";
  }

  if (props != null && props.area) {
    areaPath = "in-" + encodeURIComponent(decodeURIComponent(removeSpecialChar(props == null ? void 0 : props.area))) + "/";
  } else {
    areaPath = "in-" + process.env.GATSBY_DEFAULT_AREA.toLowerCase() + "/";
  }

  if (props != null && props.bedrooms) {
    if (parseInt(props == null ? void 0 : props.bedrooms) === 0) {
      bedPath = "studio/";
    }

    if (parseInt(props == null ? void 0 : props.bedrooms) > 0) {
      bedPath = (props == null ? void 0 : props.bedrooms) + "-and-more-bedrooms/";
    }
  }

  if (props != null && props.min_price || props != null && props.max_price) {
    if (props != null && props.min_price && props != null && props.max_price) {
      pricePath = "between-" + (props == null ? void 0 : props.min_price) + "-and-" + (props == null ? void 0 : props.max_price) + "/";
    } else if (props != null && props.max_price) {
      pricePath = "below-" + (props == null ? void 0 : props.max_price) + "/";
    } else if (props != null && props.min_price) {
      pricePath = "above-" + (props == null ? void 0 : props.min_price) + "/";
    }
  }

  if (props != null && props.building_type) {
    buildingPath = "type-" + (props == null ? void 0 : props.building_type.replace(/ /g, "-")) + "/";
  }

  if (props != null && props.sortby) {
    if ((props == null ? void 0 : props.sortby) === process.env.GATSBY_ALGOLIA_INDEX_NAME + "_price_asc") {
      sortPath = "sortby-price-asc/";
    }

    if ((props == null ? void 0 : props.sortby) === process.env.GATSBY_ALGOLIA_INDEX_NAME + "_price_desc") {
      sortPath = "sortby-price-desc/";
    }
  }

  if (props != null && props.layout) {
    layoutPath = "map-view/";
  }

  var myUrl = "/property/" + searchtypePath + areaPath + bedPath + pricePath + buildingPath + sortPath + layoutPath;
  myUrl = myUrl.toLowerCase().replace(/ /g, "-");
  return myUrl;
};

exports.createResultsUrl = createResultsUrl;

var parseResultsUrl = function parseResultsUrl(location, base_path, search_type, department_type, property_status, index_name_val) {
  if (location) {
    var pathUri_main = "";
    var departmentVal = "residential";
    var searchtypeVal = "";
    var areaVal = "";
    var bedVal = "";
    var minpriceVal = "";
    var maxpriceVal = "";
    var pageVal = "1";
    var buildingval = "";
    var sortVal = "";
    var layoutVal = "";
    var index_name = index_name_val || process.env.GATSBY_ALGOLIA_INDEX_NAME;
    var propertyTypeVal = "residential";
    var mustincludeVal = "";
    var furnishVal = "";
    var branchVal = "";
    var radiusVal = "";
    var salespage = location.pathname.indexOf("/property/for-sale") > -1;
    var lettingspage = location.pathname.indexOf("/property/to-rent") > -1;
    var newdevelopmentspage = location.pathname.indexOf("/property/new-homes/for-sale") > -1;
    var new_developments = location.pathname.indexOf("/new-developments/for-sale") > -1;
    var commercial_sale_page = location.pathname.indexOf("/commercial-property/for-sale") > -1;
    var commercial_rent_page = location.pathname.indexOf("/commercial-property/to-rent") > -1;
    var property_collection = location.pathname.indexOf("/property-collection/for-sale") > -1;
    var property_students = location.pathname.indexOf("/property-students/to-rent") > -1;

    if (base_path) {
      pathUri_main = location.pathname.split(base_path);
      searchtypeVal = search_type;
      departmentVal = department_type;
    } else {
      if (salespage === true) {
        pathUri_main = location.pathname.split("/property/for-sale");
        searchtypeVal = "sales";
      } else if (lettingspage === true) {
        pathUri_main = location.pathname.split("/property/to-rent");
        searchtypeVal = "lettings";
      } else if (newdevelopmentspage === true) {
        pathUri_main = location.pathname.split("/property/new-homes/for-sale");
        searchtypeVal = "sales";
        index_name = process.env.GATSBY_ALGOLIA_NEW_DEVELOPMENTS_INDEX_NAME || process.env.GATSBY_ALGOLIA_INDEX_NAME_NEW_DEVELOPMENT;
        propertyTypeVal = "new_developments";
      } else if (new_developments === true) {
        pathUri_main = location.pathname.split("/new-developments/for-sale");
        searchtypeVal = "sales";
        index_name = process.env.GATSBY_ALGOLIA_NEW_DEVELOPMENTS_INDEX_NAME || process.env.GATSBY_ALGOLIA_INDEX_NAME_NEW_DEVELOPMENT;
        propertyTypeVal = "newdevelopments";
      } else if (commercial_sale_page === true) {
        pathUri_main = location.pathname.split("/commercial-property/for-sale");
        searchtypeVal = "sales";
        departmentVal = "commercial";
      } else if (commercial_rent_page === true) {
        pathUri_main = location.pathname.split("/commercial-property/to-rent");
        searchtypeVal = "lettings";
        departmentVal = "commercial";
      } else if (property_collection === true) {
        pathUri_main = location.pathname.split("/property-collection/for-sale");
        searchtypeVal = "sales";
      } else if (property_students === true) {
        pathUri_main = location.pathname.split("/property-students/to-rent");
        searchtypeVal = "lettings";
      }
    }

    if (pathUri_main[1]) {
      var pathUri = pathUri_main[1].split("/");

      for (var vi = 0; vi <= pathUri.length; vi++) {
        if (typeof pathUri[vi] === "undefined") {
          continue;
        }

        if (pathUri[vi].indexOf("in-") >= 0) {
          areaVal = removeSpecialChar(pathUri[vi].replace("in-", ""), " ");
        }

        if (pathUri[vi].indexOf("-and-more-") >= 0) {
          bedVal = pathUri[vi].replace("-and-more-bedrooms", "");
        }

        if (pathUri[vi].indexOf("type-") >= 0) {
          buildingval = pathUri[vi].replace("type-", "");
        }

        if (pathUri[vi].indexOf("between-") >= 0 || pathUri[vi].indexOf("above-") >= 0 || pathUri[vi].indexOf("below-") >= 0 || pathUri[vi].indexOf("under-") >= 0 || pathUri[vi].indexOf("over-") >= 0) {
          var priceFilt1 = pathUri[vi].split("above-");

          if (priceFilt1[1]) {
            minpriceVal = priceFilt1[1];
          }

          var priceFilt2 = pathUri[vi].split("below-");

          if (priceFilt2[1]) {
            maxpriceVal = priceFilt2[1];
          }

          var priceFilt3 = pathUri[vi].split("between-");

          if (priceFilt3[1]) {
            var _priceFilt = priceFilt3[1].split("-and-");

            minpriceVal = _priceFilt[0];
            maxpriceVal = _priceFilt[1];
          }

          var priceFilt4 = pathUri[vi].split("over-");

          if (priceFilt4[1]) {
            minpriceVal = priceFilt4[1];
          }

          var priceFilt5 = pathUri[vi].split("under-");

          if (priceFilt5[1]) {
            maxpriceVal = priceFilt5[1];
          }
        }

        if (pathUri[vi].indexOf("sortby-") >= 0) {
          var sortVal_filt = pathUri[vi].replace("sortby-", "");

          if (sortVal_filt === "") {
            sortVal = index_name;
          }

          if (sortVal_filt === "price-asc") {
            sortVal = index_name + "_price_asc";
          }

          if (sortVal_filt === "price-desc") {
            sortVal = index_name + "_price_desc";
          }

          if (sortVal_filt === "newest") {
            sortVal = index_name + "_newest";
          }

          if (sortVal_filt === "oldest") {
            sortVal = index_name + "_oldest";
          }
        }

        if (pathUri[vi].indexOf("page") >= 0) {
          pageVal = pathUri[vi].replace("page-", "");
        }

        if (pathUri[vi].indexOf("map-view") >= 0) {
          layoutVal = "map";
        }

        if (pathUri[vi].indexOf("with-") >= 0) {
          var mustincludeArrfilt = pathUri[vi].replace("with-", "");
          mustincludeVal = mustincludeArrfilt.split("-and-");
        }

        if (pathUri[vi].indexOf("furnishing-") >= 0) {
          furnishVal = pathUri[vi].replace("furnishing-", "");
        }

        if (pathUri[vi].indexOf("branch-") >= 0) {
          branchVal = pathUri[vi].replace("branch-", "");
        }

        if (pathUri[vi].indexOf("radius-") >= 0) {
          radiusVal = pathUri[vi].replace("radius-", "").replace("-miles", "");
        }
      }
    }

    var mydatarr = [];
    mydatarr["indexVal"] = index_name;
    mydatarr["departmentVal"] = departmentVal;
    mydatarr["searchtypeVal"] = searchtypeVal;
    mydatarr["areaVal"] = areaVal;
    mydatarr["bedVal"] = bedVal;
    mydatarr["minpriceVal"] = minpriceVal;
    mydatarr["maxpriceVal"] = maxpriceVal;
    mydatarr["pageVal"] = pageVal;
    mydatarr["buildingval"] = buildingval;
    mydatarr["sortVal"] = sortVal;
    mydatarr["layoutVal"] = layoutVal;
    mydatarr["propertyTypeVal"] = propertyTypeVal;
    mydatarr["mustincludeVal"] = mustincludeVal;
    mydatarr["furnishVal"] = furnishVal;
    mydatarr["branchVal"] = branchVal;
    mydatarr["radiusVal"] = radiusVal;
    return mydatarr;
  }

  return false;
};

exports.parseResultsUrl = parseResultsUrl;

var generateFiltersfromPageData = function generateFiltersfromPageData(departmentVal, searchtypeVal, areaVal, bedVal, minpriceVal, maxpriceVal, buildingval, mustincludeVal, furnishVal, branchVal) {
  var myfilter = [];

  if (departmentVal) {
    myfilter.push("(department:" + departmentVal + ")");
  }

  if (searchtypeVal) {
    myfilter.push("(search_type:" + searchtypeVal + ") OR (searchType:" + searchtypeVal + ")");
  }

  if (buildingval) {
    myfilter.push("(building:" + buildingval + ")");
  }

  if (bedVal && bedVal > 0) {
    myfilter.push("(bedroom >= " + bedVal + ")");
  }

  if (minpriceVal && minpriceVal > 0 && maxpriceVal && maxpriceVal > 0) {
    myfilter.push("(price >= " + minpriceVal + " AND price <= " + maxpriceVal + ")");
  } else if (maxpriceVal && maxpriceVal > 0) {
    myfilter.push("(price <= " + maxpriceVal + ")");
  } else if (minpriceVal && minpriceVal > 0) {
    myfilter.push("(price >= " + minpriceVal + ")");
  }

  myfilter.push("(publish: true)");

  if ((mustincludeVal == null ? void 0 : mustincludeVal.length) > 0) {
    for (var v = 0; v <= mustincludeVal.length; v++) {
      if (typeof mustincludeVal[v] !== "undefined") {
        myfilter.push("(mustInclude:" + mustincludeVal[v] + ")");
      }
    }
  }

  if (furnishVal) {
    myfilter.push("(furnishing:" + furnishVal + ")");
  }

  if (branchVal) {
    myfilter.push("(office_crm_id:" + branchVal + ")");
  }

  return myfilter.join(" AND ");
};

exports.generateFiltersfromPageData = generateFiltersfromPageData;